import React from 'react'
import AllRouteUI from './routes/AllRouteUI'
import SpinnerComponentUI from './components/common/SpinnerComponentUI'
import UnrecoverableErrorUI from './components/common/UnrecoverableErrorUI'

const isClientRoute = typeof window !== 'undefined' && window.location && window.location.pathname.startsWith('/client/nach/response')

const AppUI = ({context, unrecoverableError}) =>
  <React.Fragment>
    {
      !isClientRoute && !context.session && !unrecoverableError &&
      <SpinnerComponentUI />
    }
    {
      (isClientRoute || context.session) && !unrecoverableError &&
      <AllRouteUI context={context} />
    }
    {
      unrecoverableError &&
      <UnrecoverableErrorUI context={context} unrecoverableError={unrecoverableError} />
    }
  </React.Fragment>

export default AppUI
